import "./modules/core-js";
import { collectionPagesService } from "./modules/collection-service";

$(() => collectionPagesService.setupCollectionPage());